import React from 'react';
import './Cards/Dashboard.css';
import './DashboardSkeleton.css';

const Placeholder = ({ width = '100%', height = 16, className = '' }) => <span aria-hidden="true" className={`dashboard-skeleton-block ${className}`} style={{ width, height }} />;

export default function DashboardSkeleton() {
  return <div className="module-page module-details institution-dashboard dashboard-skeleton hidethis" role="status" aria-busy="true" aria-label="Carregando dashboard">
    <span className="sr-only">Carregando indicadores e relatórios...</span>
    <section className="card module-card dashboard-overview">
      <div className="card-body">
        <div className="dashboard-heading">
          <div className="dashboard-identity">
            <Placeholder width={54} height={54} />
            <div className="dashboard-skeleton-heading"><Placeholder width="25%" height={12} /><Placeholder width="65%" height={28} /><Placeholder width="90%" /></div>
          </div>
          <Placeholder width={140} height={40} />
        </div>
        <div className="dashboard-stats">
          {Array.from({ length: 6 }, (_, index) => <div key={index} className="dashboard-stat">
            <Placeholder width={44} height={44} />
            <div className="dashboard-stat-content"><Placeholder width="70%" /><Placeholder width="40%" height={30} /><Placeholder width="90%" height={12} /></div>
          </div>)}
        </div>
        <div className="dashboard-report-picker"><Placeholder width={230} height={22} /><div className="dashboard-skeleton-options"><Placeholder height={66} /><Placeholder height={66} /></div></div>
      </div>
    </section>
    <section className="card module-card dashboard-process-picker"><div className="card-body"><Placeholder width="45%" height={24} /><Placeholder width="70%" /><div className="dashboard-skeleton-options"><Placeholder height={66} /><Placeholder height={66} /><Placeholder height={66} /></div></div></section>
    <section className="card module-card dashboard-process-content"><div className="card-body"><Placeholder width="40%" height={24} /><Placeholder width="65%" /><Placeholder height={180} /></div></section>
  </div>;
}
